@if (generalData(); as generalData) {
  <form [formGroup]="generalData">
    <ng-template matStepLabel>Technische Daten</ng-template>
    <app-required-fields />
    <div>
      <app-general-data />
      <app-technical-resource-data [isFormSubmitted]="isFormSubmitted" />
      <app-consumption-info />
      <bricks-card>
        <div class="align-right">
          <button
            type="submit"
            class="bricks-button button-fn-no-background button-icon-right"
            (click)="onSubmit(); trackEventSubmit()">
            <span>Weiter</span>
            <bricks-icon>bricks-chevron-right</bricks-icon>
          </button>
        </div>
      </bricks-card>
    </div>
  </form>
}
